import React, { useCallback, useEffect, useRef, useState } from "react";
import { useFlipperVault } from "../../../hooks/react-query/inv-exchange/useFlipperVault";
import { FlipperVaultCardProps } from "../../../stories/common/flipper-vault-card";
import styles from "./index.module.scss";
import ListRow from "./list-row";
import WebListViewSkeleton from "../../../skeleton/web-list-view-skeleton";

export default function WebListView({
  setMostVisibleCard
}: {
  setMostVisibleCard: (acctId: string | null) => void;
}) {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } =
    useFlipperVault();
  const [Address, setShowAddress] = useState("");
  const observerTarget = useRef<HTMLDivElement>(null);

  const handleObserver = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      const [target] = entries;
      if (target.isIntersecting && hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    },
    [fetchNextPage, hasNextPage, isFetchingNextPage]
  );

  useEffect(() => {
    const element = observerTarget.current;
    if (!element) return;

    const observer = new IntersectionObserver(handleObserver, {
      threshold: 0.1
    });

    observer.observe(element);

    return () => {
      if (element) observer.unobserve(element);
    };
  }, [handleObserver]);

  if (isLoading) {
    return <WebListViewSkeleton />;
  }

  return (
    <div className={styles.webListView}>
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Account</th>
            <th>Contact</th>
            <th>Interest Score</th>
            <th>Email Score</th>
            {/* <th>Total Purchase PRE</th> */}
            {/* <th>Total Flipped</th> */}
            <th>Status</th>
            <th>Time Remaining</th>
            <th>Account Owner</th>
          </tr>
        </thead>
        <tbody>
          {data?.pages &&
            data?.pages?.map((page) =>
              page?.items?.map((account: FlipperVaultCardProps) => (
                <React.Fragment key={`${JSON.stringify(account)}`}>
                  <ListRow
                    styles={styles}
                    setMostVisibleCard={setMostVisibleCard}
                    Address={Address}
                    setShowAddress={setShowAddress}
                    account={account}
                  />
                </React.Fragment>
              ))
            )}
        </tbody>
        {/* {hasNextPage && (
          <tfoot>
            <tr>
              <td colSpan={9}>
                <button
                  onClick={() => fetchNextPage()}
                  disabled={isFetchingNextPage}
                >
                  {isFetchingNextPage ? "Loading..." : "Load More"}
                </button>
              </td>
            </tr>
          </tfoot>
        )} */}
        {isLoading && (
          <tfoot>
            <tr>
              <td colSpan={9}>Loading...</td>
            </tr>
          </tfoot>
        )}
      </table>

      {/* Observer target for infinite scroll */}
      <div ref={observerTarget} style={{ height: "20px", width: "100%" }}>
        {isFetchingNextPage && (
          <div className={styles.loadingMore}>Loading more...</div>
        )}
      </div>
    </div>
  );
}
